import { useSelectRunningContext } from '../../hooks'

const NoAcessContent = () => {
  const runningContext = useSelectRunningContext()

  return (
    <div>
      {runningContext === 'inChat'
        ? `You don't have permission to access this document. Instead, you can request access to it in your system
      browser.`
        : `You don't have permission to share this document in a meeting for
      collaboration. Instead, you can request access to it in your system
      browser.`}
    </div>
  )
}

export default NoAcessContent
